import React from 'react';
import { useAuth } from './context/auth-context';
import { LoadingOverlay, useMantineTheme } from '@mantine/core';
import './App.css';
import LoginScreen from './auth/login.page';
import { Route, Navigate, Routes } from 'react-router-dom';
import { DocumentTitle } from './components/document-title/document-title';
import ErrorBoundary from './error-boundry';
import ForgotPasswordScreen from './auth/forgot.page';
import ResetPassword from './auth/reset-password.page';

const AuthenticatedApp = React.lazy(() => import('./authenticated-app'));

/**TODO: Have an un-authorized page, in-place of UnAuthenticatedApp
 * which will be used to show user is unothrized, it will be used to
 * ask user to authenticate by refreshing the page
 */
function App() {
  const { systemUser } = useAuth();
  const theme = useMantineTheme();
  console.log('systemUser?._id ', systemUser?._id);
  return (
    <React.Suspense
      fallback={
        <LoadingOverlay
          visible={true}
          loaderProps={{ color: theme.colors.secondaryColors[0] }}
        />
      }
    >
      {systemUser?._id ? (
        <AuthenticatedApp />
      ) : (
        <Routes>
          <Route
            path="/"
            element={
              <ErrorBoundary key={'Login'}>
                <DocumentTitle title="Login" />
                <LoginScreen />
              </ErrorBoundary>
            }
          />
          <Route
            path="/forgot-password"
            element={
              <ErrorBoundary key={'Forgot Password'}>
                <DocumentTitle title="Forgot Password" />
                <ForgotPasswordScreen />
              </ErrorBoundary>
            }
          />
          <Route
            path="/reset-password"
            element={
              <ErrorBoundary key={'Reset Password'}>
                <DocumentTitle title="Reset Password" />
                <ResetPassword />
              </ErrorBoundary>
            }
          />
          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />
        </Routes>
      )}
    </React.Suspense>
  );
}

export default App;
